
export const TODOS = -1;
export const REGISTRADO = 1;
export const ANULADO = 2;
export const APROBADO = 3;
export const RECHAZADO = 4;
export const IMPORTADO = 5;
export const IMPORTADO_PARCIAL = 6;



export const lista_estado = [{ id: TODOS, nombre: "Seleccionar Estado" }, { id: REGISTRADO, nombre: "REGISTRADO" }, { id: ANULADO, nombre: "ANULADO" },
{ id: APROBADO, nombre: "APROBADO" }, { id: RECHAZADO, nombre: "RECHAZADO" },
{ id: IMPORTADO, nombre: "IMPORTADO" }, { id: IMPORTADO_PARCIAL, nombre: "IMPORTADO PARCIAL" },
]

export const lista_estado_movimiento = [{ id: REGISTRADO, nombre: "REGISTRADO" }, { id: ANULADO, nombre: "ANULADO" },

{ id: APROBADO, nombre: "IMPORTADO" }]

